export class DownloadFilters {
    status: string[];
    statusName: string;
}